// Code to refacto (temporary)
import { Engine } from '../../core/Engine';
import { RepositionImageCommand } from '../Commands';

export class RepositionImageCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: RepositionImageCommand): void {
        const obj = this.engine.find(command.uuid);
        if (!obj) {
            return;
        }
        if (command.localPosition) {
            obj.transform.localPos = command.localPosition;
        }
        if (command.scale) {
            obj.transform.resize(command.scale);
        }
        if (command.rotation) {
            obj.transform.rotate(command.rotation.angle);
        }
    }
}
